import { Input } from 'lynkco-up-core';
import { UpdateVersions } from '../../modules/UpdateManagement/types';
import { BaseSyntheticEvent } from 'react';
import React from 'react';

type prop = {
  versionsObject: UpdateVersions | undefined;
  setVersionsObject: React.Dispatch<React.SetStateAction<UpdateVersions | undefined>>;
};

function ChangeVersionForm({ versionsObject, setVersionsObject }: prop) {
  if (!versionsObject) {
    return (
      <div>
        <h1>error:</h1>
        <h1>could not find a suitable version to change</h1>
      </div>
    );
  }
  const maxLength = Number(process.env.REACT_APP_COLAB_COMMENT_MAX_LENGTH) || 200;
  const stringLength = versionsObject.releaseNote?.length || 0;
  const remainingCharacters = maxLength - stringLength;

  function handleInput(event: BaseSyntheticEvent): void {
    const name = event.target.name;
    const value = event.target.value;
    if (versionsObject) {
      setVersionsObject({
        ...versionsObject,
        [name]: value,
      });
    }
  }

  return (
    <form className="mt-4 flex flex-col">
      <section className="my-0.5">
        <Input
          name="applicationName"
          onChange={handleInput}
          isDisabled
          placeholder="Application"
          defaultValue={versionsObject.applicationName}
        />
      </section>
      <section className="my-0.5">
        <Input
          name="version"
          onChange={handleInput}
          isDisabled
          placeholder="Version"
          defaultValue={versionsObject.version}
        />
      </section>

      <section className="my-1.5">
        <textarea
          className={'resize-y w-80 min-h-max max-h-72'}
          placeholder="Release Note"
          rows={4}
          value={versionsObject.releaseNote}
          defaultValue={versionsObject.releaseNote}
          name="releaseNote"
          onChange={handleInput}
          maxLength={maxLength}></textarea>

        <div className="flex items-center justify-between text-sm text-gray-500 mt-1">
          <span className={remainingCharacters ? 'invisible' : 'text-red-500'}>Maximum characters used.</span>
          <span>{`${remainingCharacters} / ${maxLength}`}</span>
        </div>
      </section>

      <section className="my-0.5">
        <select className="w-36" name="status" onChange={handleInput} defaultValue={versionsObject.status}>
          <option value={'OPTIONAL'}>Optional</option>
          <option value={'MANDATORY'}>Mandatory</option>
          <option value={'BLOCKED'}>Blocked</option>
        </select>
      </section>
    </form>
  );
}

export default ChangeVersionForm;
